const riot = require('riot');

riot.tag2('module-gallery', '<div class="s-full f fh"> <div class="relative s-full"> <div class="absolute trbl0 s-full" each="{image, index in images}"> <div class="absolute opacity-0" ref="images" if="{!image.main}" riot-style="top: {image.top}%; left: {image.left}%; z-index: {image.z ? image.z : index}; transition: {256 * (index + 1)}ms;"> <item-image_ class="image" riot-src="{image.path}"></item-image_> </div> </div> </div> </div>', 'module-gallery,[data-is="module-gallery"]{display:block}', '', function(opts) {
    this.on('mount', () => {
      this.images = [
        {path: '/images/works/works_x_01.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_x_02.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_x_03.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_x_04.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_x_05.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_x_06.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_x_07.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_x_08.jpg', top: this.randomY(), left: this.randomX()},

        {path: '/images/works/works_y_01.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_y_02.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_y_03.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_y_04.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_y_05.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_y_06.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_y_07.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_y_08.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_y_10.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_y_11.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_y_12.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_y_13.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_y_14.jpeg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_y_15.jpg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_y_16.jpg', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_y_17.JPG', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_y_18.JPG', top: this.randomY(), left: this.randomX()},
        {path: '/images/works/works_y_19.JPG', top: this.randomY(), left: this.randomX()},
      ];
      if (spat.isBrowser) {
        setTimeout(() => {
          this.refs.images.forEach((item) => {
            item.classList.remove('opacity-0');
            item.classList.add('opacity-100');
          });
        }, 128);
      }
    });

    this.randomX = () => {
      var per = 90;
      var buffer = 5;
      return Math.random() * per + buffer;
    };

    this.randomY = () => {
      var per = (app.media !== 'mobile' && app.media !== 'tablet') ? 50 : 75;
      var y = Math.random() * per;
      return y;
    };

});
riot.tag2('item-image_', '<img class="block max-h256 s-max-h128 transition object-fit-contain" riot-src="{opts.riotSrc}" onclick="{openImage}">', 'item-image_,[data-is="item-image_"]{display:inline} item-image_ img:hover,[data-is="item-image_"] img:hover{transform:scale(1.1) !important;transition:256ms !important;z-index:100 !important;box-shadow:0 4px 4px 0 #222}', '', function(opts) {
    this.openImage = (e) => {
      spat.modal.open('modal-image-single', {
        item: e.item.image,
        index: e.item.index,
        images: this.parent.images
      });
    };
});